import React, { useState, useEffect, useRef } from 'react';
import Loader from 'react-loader-spinner';
import DropIn from 'braintree-web-drop-in-react';
import axios from 'axios';
import { getNBNApiHeader } from 'utlis/commonfunctions';

const Payment = ({ customerId, Loader, state, onSuccessTap, onChangeOrderRefId, changeCouponCodeDetails, userToken,conditionAmount }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_TOKEN;
  const [loading, setLoading] = useState(false);
  const [checkTermAndContition, setcheckTermAndContition] = useState('');
  const [checkTermAndContitionAlert, setcheckTermAndContitionAlert] = useState(false);
  const [agreeTermsError, setagreeTermsError] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const [apiMessage, setApiMessage] = useState('');
  const [apiStatus, setApiStatusCode] = useState('');
  const [apiCalled, setApiCalled] = useState(false);
  const [clientToken, setClientToken] = useState('');
  const instanceRef = useRef(null);
  const [checkoutLoader, setCheckoutLoader] = useState(false);
  const [couponCode, setCounponCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [voucherCode, setVoucherCode] = useState(true);
  const [amount, setAmount] = useState(state?.amount);
  const [code, setCode] = useState('')
  const [checkTerms, setCheckTerms] = useState({
    term1: false,
    term2: false,
    term3: false,
    term4: false,
    term5:false,
    term6:false,
  });
  const[dealerName,setDealerName]=useState("")
  const[dealerEmail,setDealerEmail]=useState("")
 

  useEffect(() => {
    fetchToken();

    const releventDiv = document.getElementById('Payment');
    releventDiv.scrollIntoView({ behavior: "smooth" });
    console.log("conditionAmount",conditionAmount)

  }, []);

  const fetchToken = async () => {
    const headers = await getNBNApiHeader();
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}nbn/payments/get-client-token`,
        {
          headers: headers,
        }
      );
      const clientToken = response.data.data.clientToken;

      setClientToken(clientToken);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching client token:', error);
      setLoading(false);
    }
  };

  // const handlecheckTermAndContition = (e) => {
  //   const isChecked = e.target.checked;
  //   if (isChecked) {
  //     setcheckTermAndContition(true);
  //     setcheckTermAndContitionAlert(false);
  //     setagreeTermsError(false);
  //   } else {
  //     setcheckTermAndContition(false)
  //     setcheckTermAndContitionAlert(true);
  //     setagreeTermsError(true);
  //   }
  // }


  const handleCheckTermAndContition = (e) => {
    const { id, checked } = e.target;
    setCheckTerms(prevState => ({
      ...prevState,
      [id]: checked
    }));
    if (!checked) {
      setcheckTermAndContitionAlert(true);
      setagreeTermsError(true);
    } else {
      // Otherwise, reset the alert and error
      setcheckTermAndContitionAlert(false);
      setagreeTermsError(false);
    }
  }

  const handlesetCounponCode = (Typedvalue) => {

    setCounponCode(Typedvalue)
    if (Typedvalue.length === 0) {
      changeCouponCodeDetails('')
      setErrorMessage();
      setSuccessMessage()
    }
  }

  const applyCoupon = async (e) => {
    if(couponCode.length===0){
      return
     }
    changeCouponCodeDetails('')
    const headers = await getNBNApiHeader();
    try {
      const postData = {
        nbn_voucher_code: couponCode,
        visp_qualification_id: state.vispID,
        payable_amount: state.amount
      };

      const response = await axios.post(`${apiUrl}nbn/check-voucher-code-validity`, postData, {
        headers: headers,
      });

      if (!response.status === 200) {
        console.error('Error:', response);
        throw new Error(response.data.data.message);
      } else {
        setVoucherCode(response.data.data.voucher_name);
        setCode(couponCode)
        const voucherDetails = {
          'voucher_name': response.data.data.voucher_name,
          'new_payable_amount': response.data.data.new_payable_amount,
          'plan_amount_after_discount': response.data.data.plan_amount_after_discount,
          'voucher_amount': response.data.data.voucher_amount,
          'nbn_voucher_discounted_amount': response.data.data.nbn_voucher_discounted_amount,
          "plan_gst_inclusive_sale_amount": response.data.data.plan_gst_inclusive_sale_amount,
          "nbn_credit_added":response.data.data.nbn_credit_added,
        }


        if (response.data.data.new_payable_amount < 1) {
          setVoucherCode(null); // Hide payment gateway
        } else {
          setVoucherCode(true);
        }
        changeCouponCodeDetails(voucherDetails)
        setErrorMessage();
        setSuccessMessage(response.data.message)

      }

    } catch (error) {
      setVoucherCode(true);
      setErrorMessage(error.response.data.message);
      setSuccessMessage('')
    }
  }

  const buy = async (e) => {
    e.preventDefault();
    const headers = await getNBNApiHeader();
    // if (!checkTermAndContition) {
    //   setcheckTermAndContition(false)
    //   setcheckTermAndContitionAlert(true);
    //   setagreeTermsError(true);
    //   return; // Stop the function execution
    // }
    const allChecked = Object.values(checkTerms).every(term => term);

    if (!allChecked) {
      setcheckTermAndContitionAlert(true);
      setagreeTermsError(true);
      return; // Stop the function execution
    }

    try {
      let nonce = 'False';

      if (voucherCode&&conditionAmount>="1") {
        const { nonce: generatedNonce } = await instanceRef.current.requestPaymentMethod();
        nonce = generatedNonce;
      }
      const requestData = {
        nonce: nonce,
        visp_qualification_id: state.vispID,
        nbn_voucher_code: code,
        shipping_charge: state.shipping_charge,
        payable_amount: state.amount,
        order_submitted_by:dealerName,
        order_submitted_email:dealerEmail,
      };


      setCheckoutLoader(true);

      const response = await axios.post(
        `${apiUrl}nbn/customer-purchase-payment`,
        requestData,
        {
          headers: headers,
        }
      );


      if (response.status === 200) {
        setApiCalled(true);
        const data = response.data;

        setApiMessage([data.message]);
        setApiStatusCode(data.status);

        onChangeOrderRefId(data.data.ordRefID);
        onSuccessTap();
      } else {
        setApiCalled(true);
        throw new Error('Failed to make the API call');
      }
    } catch (error) {
       console.log("paymentError",error)

      setApiCalled(true);
      setApiStatusCode(false);
      setApiMessage(error.response ? error.response.data.message : error.message);
    } finally {
      setCheckoutLoader(false);
    }
  };

  const handleDealerName=(e)=>{
    setDealerName(e.target.value)    
  }
  const handleDealerEmail=(e)=>{ 
    setDealerEmail(e.target.value)
  }
  

  return (
    <div id="Payment" className="tabcontent">
      <div>
        {loading ? (
          <div>
            <Loader
              type="Puff"
              color="#00BFFF"
              height={100}
              width={100}
              timeout={4000}
            />
          </div>
        ) : (
          <div>
            {!clientToken ? (
              <div>
                <Loader
                  type="Puff"
                  color="#00BFFF"
                  height={100}
                  width={100}
                  timeout={3000}
                />
              </div>
            ) : (
              <div>
                <div className="form-field col-lg-12">
                  <label className="label" htmlFor="mobile">
                    {/* Special promo code or did a friend refer you? */}
                    Enter promo code here
                  </label>
                  <div className="input-group">
                    <input type="text" className="input form-control" onChange={e => handlesetCounponCode(e.target.value)} name="coupon" /> <br></br> <a className='btn btn-success coupon-btn' onClick={applyCoupon}>Apply </a>
                  </div>
                  {errorMessage && (
                    <p style={{ color: 'red', textAlign: 'left' }}>
                      <span style={{ marginRight: '5px' }} role="img" aria-label="Error">&#9888;</span>
                      {errorMessage}
                    </p>
                  )}
                  {successMessage && (
                    <p style={{ color: 'green', textAlign: 'left' }}>
                      <span role="img" aria-label="Success">&#10004;</span> {successMessage}
                    </p>
                  )}
                  <p style={{ textAlign: 'left', textDecoration: 'underline', marginTop: '10px', display: 'none' }}>Have an agent code?</p>

                </div>
                    {voucherCode && conditionAmount >"1" && (
                      <>
                      <br/>
                      <label className='dealer-responsive-label' >Please add payment card details of customer. Do not add dealer payment card details here. </label>
                      
                      <DropIn
                        options={{
                          authorization: clientToken,
                        }}
                        onInstance={(instance) => (instanceRef.current = instance)}
                      />
                      </>
                    )}

                <br />
                <p style={{ textAlign: 'left' }}>Terms and conditions:</p>
                {/* <label className="check-box" style={checkTermAndContitionAlert ? { color: '#777' } : {}}>
                  I have read and accept the <span style={checkTermAndContition ? { color: '#d30058' } : { color: 'red' }}><a target="_blank" href='https://www.telsim.com.au/website-terms-conditions/' style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }} >Terms & Conditions</a></span>, the Acceptable Use Policy,
                  the <span style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }} ><a target="_blank" href='https://www.telsim.com.au/website-privacy-policy/' style={checkTermAndContition ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }}>Privacy Policy</a></span> for my Telsim service.
                  <input type="checkbox" required="" id="agreeTerms"  title="Please check and agree to the terms and conditions"  value={checkTermAndContition} onChange={handlecheckTermAndContition} />
                  <span className="tick"></span>
                </label> */}

                <label className="check-box" style={checkTermAndContitionAlert ? { color: '#777' } : {}}>
                Customer agreed to the Telsim <span style={checkTerms.term1 ? { color: '#d30058' } : { color: 'red' }}>
                    <a target="_blank" href='https://www.telsim.com.au/website-terms-conditions/'
                      style={checkTerms.term1 ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }}>
                      Terms & Conditions
                    </a>
                  </span>
                   <span></span> And the Acceptable Use Policy, <span style={checkTerms.term1 ? { color: '#d30058' } : { color: 'red' }}>
                    <a target="_blank"  href='https://www.telsim.com.au/website-privacy-policy/'
                      style={checkTerms.term1 ? { color: '#d30058', textDecoration: 'none' } : { color: '#d30058', textDecoration: 'none' }}>
                       Privacy Policy.
                    </a>
                  </span>
                  <input type="checkbox" required id="term1" title="Please check and agree to the terms and conditions"
                    checked={checkTerms.term1} onChange={handleCheckTermAndContition} />
                  <span className="tick"></span>
                </label>

                <label className="check-box" style={checkTermAndContitionAlert ? { color: '#777' } : {}}>
                Customer is aware that his card will be charged 1 AUD for card preauthorization. This pending transaction will be voided by bank automatically within 7-14 business days.
                  
                   <span style={checkTerms.term2 ? { color: '#d30058' } : { color: 'red' }}>
                  </span>
                  <input type="checkbox" required id="term2" title="Please check and agree to the terms and conditions"
                    checked={checkTerms.term2} onChange={handleCheckTermAndContition} />
                  <span className="tick"></span>
                </label>

                <label className="check-box" style={checkTermAndContitionAlert ? { color: '#777' } : {}}>
                This payment method will be used for all future NBN payments for this account. Payment method can be updated anytime in Telsim My Account. 
                  <span style={checkTerms.term3 ? { color: '#d30058' } : { color: 'red' }}>
                  </span>
                  <input type="checkbox" required id="term3" title="Please check and agree to the terms and conditions"
                    checked={checkTerms.term3} onChange={handleCheckTermAndContition} />
                  <span className="tick"></span>
                </label>


                <label className="check-box" style={checkTermAndContitionAlert ? { color: '#777' } : {}}>
                I have performed a visual check of customer’s ID document (Passport, AU Driving License, Medicare card). 
                 <span style={checkTerms.term4 ? { color: '#d30058' } : { color: 'red' }}>
                  
                  </span>
                  <input type="checkbox" required id="term4" title="Please check and agree to the terms and conditions"
                    checked={checkTerms.term4} onChange={handleCheckTermAndContition} />
                  <span className="tick"></span>
                </label>

                <label className="check-box" style={checkTermAndContitionAlert ? { color: '#777' } : {}}>
                I have verified that the customer's name and address match the service address provided using the ID document or rental agreement or a utility bill. 
                  
                   <span style={checkTerms.term5 ? { color: '#d30058' } : { color: 'red' }}>
                  </span>
                  <input type="checkbox" required id="term5" title="Please check and agree to the terms and conditions"
                    checked={checkTerms.term5} onChange={handleCheckTermAndContition} />
                  <span className="tick"></span>
                </label>

                <label className="check-box" style={checkTermAndContitionAlert ? { color: '#777' } : {}}>
                I have informed and customer is aware that Telsim do not provide Home Phone Services. <br></br>
              <small>Note: If the customer currently have a Home Phone (VoIP) service with current provider, please DO NOT cancel. Terminating existing phone service might result in the permanent loss of phone number.</small>
                  
                   <span style={checkTerms.term6 ? { color: '#d30058' } : { color: 'red' }}>
                  </span>
                  <input type="checkbox" required id="term6" title="Please check and agree to the terms and conditions"
                    checked={checkTerms.term6} onChange={handleCheckTermAndContition} />
                  <span className="tick"></span>
                </label>


                <div className="form-field col-lg-12 ">
                  <p style={{ fontSize: 15, }}>Order Submitted by:</p>
                  <input type="text" required placeholder='Please enter your name to get commission on activation.'  autoComplete="off" className="dealer" name="person_accepting_delivery" onChange={handleDealerName} />
                </div>
                <div className="form-field col-lg-12 ">
                  <p style={{ fontSize: 15, }}>Order Submitted Person Email:</p>
                  <input type="email" required pattern="[^@\s]+@[^@\s]+\.[^@\s]+" title='Please enter the email that you wish to receive the eVisa card for staff incentive' placeholder='Please enter the email that you wish to receive the eVisa card for staff incentive'  autoComplete="off" className="dealer" name="order_submitted_email" onChange={handleDealerEmail} />
                </div>
                <br />
                <div className="row">
                  <div className="form-field col-lg-12">
                    <input className="payment-submit-btn" type="submit" value="CONTINUE" disabled={errorMessage} onClick={buy} />
                  </div>
                </div>
                <br></br>
                {apiCalled && (
                  <div>
                    {apiStatus === 200 ? (
                      <div className="alert alert-success">
                        <strong>Successfully Submitted!</strong> {apiMessage}
                      </div>
                    ) : (
                      <div className="alert alert-danger">
                        <strong> Your payment method failed.</strong>{apiMessage}
                      </div>
                    )}
                  </div>
                )}
                {agreeTermsError === true && (
                  <>
                    <br />
                    <div className="alert alert-danger">
                      <strong>Please  Select All checkboxes</strong>
                    </div>
                  </>
                )}
                 {emailError === true && (
                  <>
                    <br />
                    <div className="alert alert-danger">
                      <strong>Please Enter a Valid Email Address</strong>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      <br></br>
      {checkoutLoader && (
        <div className="checkoutloader">
          <Loader
            type="Puff"
            color="#00BFFF"
          />
        </div>
      )}
    </div>
  );
};

export default Payment;
